import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import { Tabs } from "@mui/material";
import React from "react";

export default function ChartTabs({tabs, values, ariaLabel, panels }: { tabs: React.ReactNode[], values: string[], ariaLabel: string, panels: React.ReactNode[] }) {
    const [value, setValue] = React.useState(values[0]);
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>  
            {/* <Card sx={{ width: '100%', height: '100%', boxShadow: 'none'}}>
                <CardContent sx={{ padding: 0 }}> */}
                    <Box sx={{ width: '100%', typography: 'body1', height: '100%', margin: 0, padding: 0 }}>
                        <TabContext value={value}>
                            <Box sx={{ margin: 0.25, padding: 0 }}>
                                <Tabs 
                                    variant="scrollable"
                                    scrollButtons
                                    allowScrollButtonsMobile
                                    selectionFollowsFocus
                                    onChange={handleChange} 
                                    aria-label={ariaLabel}
                                    value={value}
                                >   
                                    {tabs}
                                </Tabs>
                                {panels.map((panel, index) => (
                                    <TabPanel key={index} value={values[index]} sx={{ margin: 0, padding: 0 }}>
                                        {panel}
                                    </TabPanel>
                                ))}
                            </Box>
                        </TabContext>
                    </Box>
                {/* </CardContent>
            </Card> */}
        </Box>
    )
}